<template>
	<div class="d-bg">
		<img src="../assets/images/declare/bg.png" />
		<img src="../assets/images/declare/bg.png" class="imgHidden" />
		<div class="d-box">
			<div class="d-conter" @click="closeClick">
				<div class="s-title">申报信息填写</div>
				<div class="s-page-box">
					<div class="d-input-h" @click.stop="openSelect">
						<div class="d-input-lable">*申报项目</div>
						<div class="d-input-box">
							<div class="d-input-text" @click.stop="openSelect">
								<font class="grayText" v-if="applyInfo.type==0">请选择</font>
								<font v-else>{{selectName}}</font>
							</div>
							<div class="d-sel-box" v-show="selectPupopIf">
								<div class="d-sel-ul">
									<div class="d-sel-li" v-for="(item,index) in selectList" :key="index">
										<div :class="['d-sel-cell',item.isSelect]" @click.stop="selectClick(index)">
											<font>{{item.name}}</font>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="s-desc-text" v-if="ifText1">*请选择</div>
					<!-- ================== -->
					<div class="d-input-h">
						<div class="d-input-lable">*联系人</div>
						<div class="d-input-box">
							<input type="text" v-model="applyInfo.name" placeholder="请输入联系人姓名" />
						</div>
					</div>
					<div class="s-desc-text" v-if="ifText2">*请输入联系人姓名</div>
					<!-- ================== -->
					<div class="d-input-h">
						<div class="d-input-lable">*联系方式</div>
						<div class="d-input-box">
							<input type="text" v-model="applyInfo.tel" placeholder="请输入联系人方式" />
						</div>
					</div>
					<div class="s-desc-text" v-if="ifText3">*请输入联系人方式</div>
					<!-- ================== -->
					<div class="d-input-h">
						<div class="d-input-lable">*出险经过说明</div>
						<div class="d-input-box">
							<input type="text" v-model="applyInfo.desc" placeholder="请输入经过" />
						</div>
					</div>
					<div class="s-desc-text" v-if="ifText4">*请输入经过</div>
					<!-- ================= -->
					<div class="i-btn-box">
						<div class="d-input-btn" @click="goSumbit">提交</div>
						<div class="d-input-clear" @click="goClear">重置</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data() {
			return {
				selectName:'',
				selectList:[
					{
						type:1,
						isSelect:'select',
						name:'产品责任险'
					},
					{
						type:2,
						isSelect:'',
						name:'场地公众责任险'
					},
					{
						type:3,
						isSelect:'',
						name:'无忧充电服务'
					},
				],
				selectPupopIf:false,
				applyInfo: {
					type: 0,
					name: '',
					tel: '',
					desc: ''
				},
				ifText1:false,
				ifText2:false,
				ifText3:false,
				ifText4:false
			}
		},
		methods: {
			//选择类型
			selectClick(index){
				var self = this
				for(var i in self.selectList){
					var dataInfo = self.selectList[i]
					if(dataInfo.isSelect){
						dataInfo.isSelect = ''
					}
				}
				self.selectPupopIf = false
				var obj = self.selectList[index]
				obj.isSelect = 'select'
				self.applyInfo.type = obj.type
				self.selectName = obj.name
			},
			openSelect(){
				var self = this
				console.log('=============')
				if(self.selectPupopIf){
					self.selectPupopIf = false
				}else{
					self.selectPupopIf = true
				}
			},
			closeClick(){
				var self = this
				self.selectPupopIf = false
			},
			goClear(){
				var self = this
				self.applyInfo = {
					type: 0,
					name: '',
					tel: '',
					desc: ''
				}
				self.selectName = ''
			},
			goSumbit(){
				var self = this
				console.log('=========>')
				self.ifText1 = false
				self.ifText2 = false
				self.ifText3 = false
				self.ifText4 = false
				if(self.applyInfo.type==0){
					self.ifText1 = true
					return
				}
				if(!self.applyInfo.name){
					self.ifText2 = true
					return
				}
				if(!self.applyInfo.tel){
					self.ifText3 = true
					return
				}
				if(!self.applyInfo.desc){
					self.ifText4 = true
					return
				}
				self.netFormSumbit()
			},
			netFormSumbit(){
				var self = this
				let param = {
					type:self.applyInfo.type,
					contacts:self.applyInfo.name,
					mobile:self.applyInfo.tel,
					desc:self.applyInfo.desc
				}
				var url = "https://issks.com/api/insure_apply/apply"
				axios.post(url, param).then(res => {
					self.goClear()
					self.$message({
						message: "提交成功！",
						//type 取值 success(成功) /warning(警告)/info(消息)/error(错误)/;
						type: "success",
					});
				}).catch(err => {
				  
				})
			}
		}
	}
</script>

<style>
	.imgHidden{
		display: none;
	}
	.d-bg{
		background-color: #fff;
		max-height: 50rem;
		overflow: hidden;
		position: relative;
	}
	.d-box{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-flow: column;
		position: absolute;
		top: 0;
		left: 0;
	}
	.d-conter{
		width: 55%;
		padding: 1rem .5rem;
		margin-top: 5rem;
		border-radius: 1rem;
		background-color: #fff;
	}
	.s-title{
		font-size: 2.5rem;
		font-weight: bold;
		color: #8CBC4A;
	}
	/* =================== */
	.s-page-box{
		width: 80%;
		margin: 3rem auto 0;
	}
	/* ================================= */
	.d-input-h {
		padding: 1.5rem;
		border: .1rem solid #EEEEEE;
		margin-top: 1.5rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 1rem;
	}
	
	.d-input-lable {
		flex: 3;
		margin-right: 1rem;
		font-weight: 600;
		color: #636363;
	}
	.d-input-box{
		flex: 13;
		text-align: left;
		position: relative;
	}
	.d-input-box input {
		width: 100%;
		font-size: .8rem;
	}
	.d-input-text{
		font-size: .8rem;
	}
	.d-input-text .grayText{
		color: #868686;
	}
	.i-btn-box{
		width: 80%;
		margin: 4rem auto 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		text-align: center;
		font-size: 1.5rem;
		font-weight: bold;
	}
	.d-input-btn {
		width: 45%;
		padding: 1rem 0;
		background-color: #8DBB49;
		border: .1rem solid #8DBB49;
		border-radius: .8rem;
		color: #fff;
		cursor: pointer;
	}
	.d-input-clear{
		width: 45%;
		padding: 1rem 0;
		border: .1rem solid #b1b1b1;
		border-radius: .8rem;
		color: #b1b1b1;
		cursor: pointer;
	}
	/* ========================= */
	.d-sel-box{
		background-color: #fff;
		position: absolute;
		top: 140%;
		left: 0;
		z-index: 9;
	}
	.d-sel-ul{
		min-width: 10rem;
		border: .1rem solid #F1F1F1;
	}
	.d-sel-li{
		border-bottom: .1rem solid #F1F1F1;
	}
	.d-sel-li .select{
		background-color: #2ccdf1;
		color: #fff;
	}
	.d-sel-cell{
		padding: 1rem 2rem;
	}
	@media screen and (max-width:750px) {
		.imgHidden{
			display: block;
		}
		.d-conter{
			width: 90%;
			margin-top: 2rem;
		}
		.s-title{
			font-size: 1.5rem;
			font-weight: bold;
			color: #8CBC4A;
		}
		/* =================== */
		.s-page-box{
			width: 90%;
			margin: .5rem auto 0;
		}
		/* ================================= */
		.d-input-h {
			padding: .8rem;
			border: .1rem solid #EEEEEE;
			margin-top: .8rem;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 1rem;
		}
		
		.d-input-lable {
			flex: 6;
			margin-right: .5rem;
			text-align: right;
			font-size: .8rem;
			font-weight: 600;
			color: #636363;
		}
		.d-input-box{
			flex: 13;
			text-align: left;
			position: relative;
		}
		.d-input-box input {
			width: 100%;
			font-size: .8rem;
		}
		.d-input-text{
			font-size: .8rem;
		}
		
		/* ========================= */
		.d-sel-box{
			background-color: #fff;
			position: absolute;
			top: 140%;
			left: 0;
			z-index: 9;
		}
		.d-sel-ul{
			min-width: 10rem;
			border: .1rem solid #F1F1F1;
		}
		.d-sel-li{
			border-bottom: .1rem solid #F1F1F1;
		}
		.d-sel-li .select{
			background-color: #2ccdf1;
			color: #fff;
		}
		.d-sel-cell{
			padding: 1rem 2rem;
		}
		/* ====================== */
		.i-btn-box{
			width: 80%;
			margin: 4rem auto 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
			font-size: 1rem;
			font-weight: bold;
		}
	}
	
</style>